import api from "./api";
import { iniciarRequisicao } from "./../helpers/index.js";

class ImportAPI {
  async getDadosProdutosAnaliseMercado() {
    const headers = iniciarRequisicao();
    const response = await api.get("/imports/get-dados-produtos-analise-mercado", { headers });
    return response;
  }

  async getDadosExpandedProdutosAnaliseMercado(params) {
    const headers = iniciarRequisicao();
    const response = await api({
      method: 'post',
      url: '/imports/get-dados-expanded-produtos-analise-mercado',
      headers,
      data: params
    });
    return response;
  }

  async importarDadosTemporarioPlanilha(headers, params) {
    const response = await api({
      method: 'post',
      url: '/imports/importar-dados-temporario-planilha',
      headers,
      data: params
    });
    return response;
  }

  async salvarDadosTemporarioPlanilha(params) {
    const headers = iniciarRequisicao();
    const response = await api({
      method: 'post',
      url: '/imports/salvar-dados-temporario-planilha',
      headers,
      data: params
    });
    return response;
  }
}

export default new ImportAPI();
